import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import PageLoader from "@/components/Loaders/PageLoader";
import { store } from "@store/store";
import { clearCredentials } from "@store/slices/authSlice";
import { useRouteAuthorization } from "@/hooks/useRouteAuthorization";

const AdminLayout = lazy(() => import("@layout/AdminLayout"));

const MainRoutes = () => {
  const { flatRoutes } = useRouteAuthorization();

  // A role with no agency-panel pages (e.g. SUPER_ADMIN) must not loop to a blank screen.
  if (!flatRoutes.length) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-3 p-6 text-center">
        <p className="text-base font-semibold text-gray-800">This account has no access to the agency panel.</p>
        <button
          className="rounded-lg bg-black px-4 py-2 text-sm text-white"
          onClick={() => { store.dispatch(clearCredentials()); window.location.href = "/auth/login"; }}
        >
          Log out
        </button>
      </div>
    );
  }

  return (
    <Routes>
      <Route element={
        <Suspense fallback={<PageLoader />}>
          <AdminLayout />
        </Suspense>
      }>
        {flatRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <Suspense fallback={<PageLoader />}>
                <route.component />
              </Suspense>
            }
          />
        ))}

        {/* fallback */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
};

export default MainRoutes;
